import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML, encodeHTML } from "@utils/CommonUtils";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper, Loader } from "~/Components";
import { magpCMSApi } from "~/Services";
import { useAuth } from "~/Hooks/useAuth";
import { post, put } from "~/Services";
import { magpHost } from "~/Utils";
import { fields } from "../constants";
import { useCPOsOffice, useExcellence } from "../ContactDirectory.hook";

export const AddEdit = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();

  const {
    data: editGallery,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchEditGallery,
  } = useExcellence(query.get('editId')||"", query.get("contactDirKey")||"");

  const {
    data: GalleryById,
    isLoading: isLoadingFaq,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchEditGallery();
    }
  }, [query.get("editId"), query.get("id")]);

  const faqFormConfig: FormConfig = {
    initialValues: {
    field_profile_name_en: GalleryById
        ? decodeHTML(GalleryById.payload.field_profile_name_en)
        : editGallery
          ? decodeHTML(editGallery?.[0]?.field_profile_name_en)
          : "",
    field_profile_name_ms: GalleryById ? decodeHTML(GalleryById.payload.field_profile_name_ms) : editGallery ? decodeHTML(editGallery?.[0]?.field_profile_name_ms) : "",
    field_profile_name_zh: GalleryById
        ? decodeHTML(GalleryById.payload.field_profile_name_zh)
        : editGallery
          ? decodeHTML(editGallery?.[0]?.field_profile_name_zh)
          : "",
    field_profile_designation_en: GalleryById
        ? decodeHTML(GalleryById.payload.field_profile_designation_en)
        : editGallery
          ? decodeHTML(editGallery?.[0]?.field_profile_designation_en)
          : "",
    field_profile_designation_ms: GalleryById
        ? decodeHTML(GalleryById.payload.field_profile_designation_ms)
        : editGallery
          ? decodeHTML(editGallery?.[0]?.field_profile_designation_ms)
          : "",
    field_profile_designation_zh: GalleryById
        ? decodeHTML(GalleryById.payload.field_profile_designation_zh)
        : editGallery
          ? decodeHTML(editGallery?.[0]?.field_profile_designation_zh)
          : "",
    field_unit_subcategory_en: GalleryById
          ? decodeHTML(GalleryById.payload.field_unit_subcategory_en)
          : editGallery
            ? decodeHTML(editGallery?.[0]?.field_unit_subcategory_en)
            : "",
    field_unit_subcategory_ms: GalleryById
          ? decodeHTML(GalleryById.payload.field_unit_subcategory_ms)
          : editGallery
            ? decodeHTML(editGallery?.[0]?.field_unit_subcategory_ms)
            : "",
    field_unit_subcategory_zh: GalleryById
          ? decodeHTML(GalleryById.payload.field_unit_subcategory_zh)
          : editGallery
            ? decodeHTML(editGallery?.[0]?.field_unit_subcategory_zh)
            : "",
    field_email_id: GalleryById
            ? decodeHTML(GalleryById.payload.field_email_id)
            : editGallery
              ? decodeHTML(editGallery?.[0]?.field_email_id)
              : "",
    field_phone_number: GalleryById
            ? decodeHTML(GalleryById.payload.field_phone_number)
            : editGallery
              ? decodeHTML(editGallery?.[0]?.field_phone_number)
              : "",
    field_contact_profile_published: GalleryById ? GalleryById.payload.field_contact_profile_published : editGallery ? editGallery?.[0]?.field_contact_profile_published : "",
    },
    fields: fields.excellence,
  };
     const [isLoading, setIsLoading] = useState(false);
      const [tabs,setTabs]=useState([])
      const [id,setId]=useState(0)
  
    const getRecords = () => {
        setIsLoading(true);
        let url = `/api/get-contact-directory-departments/all-fields`;
        magpCMSApi
          .get(url)
          .then((res: any) => {
            if (res && res.data) {
              let tabslist = res.data;
              setTabs(tabslist);
              setId(tabslist?.find((tab: any) => tab.name === query.get("contactDirKey"))?.id)
            }
            setIsLoading(false);
          })
          .catch((err) => {
            setTabs([]);
            setIsLoading(false);
          });
      };
  
    useEffect(() => {
      getRecords();
    }, []);
  

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let excludedKeys: any = [];
    // for (let key in data) {
    //   if (typeof data[key] === "string" && !excludedKeys.includes(key)) {
    //     data[key] = encodeHTML(data[key]);
    //   }
    // }
    let imageKeys: any = [
      "fbImage",
      "field_purchase_login_pop_image",
      "field_login_image",
      "filledImage",
      "googleImage",
      "showImage",
      "field_logout_image",
    ];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "MAGP");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }

    let publishKey: any=[
      'field_contact_profile_published'
    ]
    for (const key of publishKey) {
      data[key] = !!data[key];
    } 

    const payload = {
      action: action,
      method: method,
      module: "Contact Directory",
      subModule: `${query.get("contactDirKey")||
    GalleryById?.subModule}`,
      type: "DEDICATED",
      application: "MAGP",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "MAGP",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...data,
        field_department_reference: id || GalleryById?.payload?.field_department_reference,
        // published: true 
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response:any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === 'OK' && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else{
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response:any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === 'OK' && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else{
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
  <ContentWrapper title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} ${query.get("contactDirKey") ||
    GalleryById?.subModule ||
    ""
}`}
  showBack>
    <DynamicForm
        isLoading={isLoadingFaq || drilldownLoading}
        config={faqFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            query.get("editId") || query.get("type") === 'update'
              ? `${magpHost}/api/web-contact-directory-profile${(editGallery?.[0]?.id || GalleryById?.payload?.id) ? `/${editGallery?.[0]?.id || GalleryById?.payload?.id}` : ""}`
              : `${magpHost}/api/create/web-contact-directory-profile`,
            query.get("editId") || query.get("type") === 'update' ? "UPDATE" : "CREATE",
            query.get("editId") || query.get("type") === 'update' ? "PATCH" : "POST",
            buttonValue === "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }        
      />
  </ContentWrapper>
  );
};
